import Http from './http'

export default {
  index(filter) {
    return Http.get(`/reproved_done_items`, {
      params: {
        // solution_id: localStorage.getItem("solution_id"),
        ...filter,
      },
    });
  },
}
